// src/api/categoryApi.js
import apiClient from './axios';

const categoryApi = {
  // GET all (pagination + search)
  getAll: async (page = 1, pageSize = 10, search = '') => {
    const response = await apiClient.get('/categories/', {
      params: { 
        page, 
        page_size: pageSize,
        search: search.trim() || undefined  // Only send if not empty
      },
    });
    return response.data; // { data: [...], pagination: {...} }
  },

  getById: async (id) => {
    const response = await apiClient.get(`/categories/${id}/`);
    return response.data;
  },

  create: async (data) => {
    const response = await apiClient.post('/categories/', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await apiClient.patch(`/categories/${id}/`, data);
    return response.data;
  },

  delete: async (id) => {
    await apiClient.delete(`/categories/${id}/`);
    return true;
  },

  exportCsv: async () => {
    const response = await apiClient.get('/categories/export/', {
      responseType: 'blob',
    });
    return response.data;
  },

  importPreview: async (file) => {
    const form = new FormData();
    form.append('file', file);
    const response = await apiClient.post('/categories/import-preview/', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  importConfirm: async (preview) => {
    const response = await apiClient.post('/categories/import-confirm/', { preview });
    return response.data;
  },
};

export default categoryApi;